export default __webpack_public_path__ + "static/media/hht2_storybook_15.b5d5be2a.png";